<template>
    <div class="cuponContainer" :style="{ padding: isTabView ? '0px 0px' : '70px 0px 0px' }">
        <CustomHeader v-if="!isTabView" :text="$t('giftCode.exchangeReward')" />
        <div class="gift-banner">
            <img :src="dataSet.bannerIcon" alt="banner" class="banner-img" />

            <div class="middleCard">
                <van-row class="couponInput">
                    <van-col span="24"><van-field class="pasteInput" :placeholder="$t('giftCode.enterCode')"
                            v-model="couponCode" /></van-col>
                </van-row>
                <div class="top-text">{{ $t('giftcode.multimedia') }}</div>
                <div class="small-text">{{ $t('giftcode.note') }}</div>
                <div class="btn_container">
                    <MainButton :title="$t('common.register')" :activeStatus="true" @click="claimSubmit"
                        radius="10px !important" />
                </div>

                <div class="mediaIcons">
                    <img src="@/assets/sideNavbar/Telegram_cai.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/sideNavbar/Whatsapp_cai.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/sideNavbar/facebook_cai.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/bauDo/instagram_icon.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/sideNavbar/18+_cai.png" alt="banner" class="media-img" @click="goToShare" />
                </div>
            </div>
        </div>


        <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">

import { GiftCodeData } from '@/view/giftCode/giftCodeView';
import { watch, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import MainButton from '../components/common/mainButton.vue';

const emits = defineEmits(['pasteCode', 'goToShare', 'claimSubmit'])

const props = defineProps<{
    dataSet: GiftCodeData
    isTabView?: boolean
}>()

const couponCode = ref(props.dataSet.couponCode)

watch(
    () => props.dataSet.couponCode,
    val => (couponCode.value = val)
);

const pasteCode = async () => {
    try {
        const text = await navigator.clipboard.readText();
        if (!text) return;

        couponCode.value = text;
        emits('pasteCode', text);
    } catch (err) {
        console.error('Paste failed', err);
    }
};
const claimSubmit = () => {
    emits('claimSubmit', couponCode.value)
}
const goToShare = async () => {
    emits("goToShare")
}

</script>
<style scoped>
.cuponContainer {
    padding: 0px 0;
    /* min-height: 100vh; */
}

.gift-banner {
    position: relative;
    max-width: 100%;
    margin: 0;
}

.banner-img {
    width: 100%;
}

.btn_container {
    margin: 10px 0 25px;
}

.couponInput {
    margin: 20px 0;
    color: rgb(255, 255, 255, 0.4);
    border: 1px solid rgb(0, 97, 95);
    background-color: rgb(0, 33, 33);
    border-radius: 10px;
}

.mediaIcons {
    border-radius: 10px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.mediaIcons img {
    width: 35px;
    padding: 5px 10px;
}

.bottom_text {
    padding: 25px;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 15px;
    padding: 10px;
    font-weight: 500;
    line-height: 22.5px;
}

.middleCard {
    display: flex;
    flex-direction: column;
    padding: 0 15px;
}

.top-text {
    color: rgb(252, 151, 76);
    font-size: 20px;
    font-weight: bold;
    pointer-events: none;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.small-text{
    color: rgb(256, 256, 256, 0.4);
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
}
.couponInput ::v-deep .van-field {
    line-height: 1.64rem !important;
    background: transparent !important;
    font-size: 10px !important;
}

.couponInput ::v-deep .van-field__control {
    font-size: 15px;
    padding: 5px 0px;
    color: #ffffff !important;
}

::v-deep(.pasteInput .van-field__control::placeholder) {
    color: rgba(255, 255, 255, 0.4) !important;
    font-size: 16px;
    font-weight: 500;
}

@media (max-width: 400px) {
    .top-text {
        font-size: 16px;
    }

    ::v-deep(.pasteInput .van-field__control::placeholder) {
        font-size: 14px;
    }
}
</style>